var $ad9be5d332b4d607$exports = {};
$ad9be5d332b4d607$exports = {
  "breadcrumbs": "\uD0D0\uC0C9 \uD45C\uC2DC"
};
export { $ad9be5d332b4d607$exports as default };